import { observable, makeObservable, action } from 'mobx';
import { MainStore } from './MainStore';
import { IArticleSetItem } from './types';
import { IPdpResponseData } from './pdpTypes';

export class ProductInfoStore {
    public readonly mainStore: MainStore;

    // @observable:
    // UI
    public isDetailsModalOpen: boolean = false;
    public articleSetItemDetail: IPdpResponseData | null = null;
    public openedArticleSetItem: IArticleSetItem | null = null;
    public productInfoExpanded: boolean = false;
    public productInfoBig: boolean = false;
    public shutterExpanded: boolean = false;
    // Click behavior to open the details page of single articles via details modal depending from where the
    public itemOrigin: string = ''; // for piwik

    constructor(mainStore: MainStore) {
        this.mainStore = mainStore;

        makeObservable(this, {
            isDetailsModalOpen: observable,
            setDetailsModalOpen: action,
            articleSetItemDetail: observable,
            setArticleSetItemDetail: action,
            openedArticleSetItem: observable,
            setOpenedArticleSetItem: action,
            productInfoExpanded: observable,
            setProductInfoExpanded: action,
            productInfoBig: observable,
            setProductInfoBig: action,
            shutterExpanded: observable,
            setShutterExpanded: action,
            itemOrigin: observable,
            setItemOrigin: action
        });

        this.itemOrigin = 'ArticleSet'; // default value
    }

    setItemOrigin(value: string) {
        this.itemOrigin = value;
    }

    setDetailsModalOpen(value: boolean) {
        this.isDetailsModalOpen = value;
    }

    setArticleSetItemDetail(articleSetItem: IPdpResponseData | null) {
        this.articleSetItemDetail = articleSetItem;
    }

    setOpenedArticleSetItem(articleSetItem: IArticleSetItem | null) {
        this.openedArticleSetItem = articleSetItem;
    }

    setProductInfoExpanded(value: boolean) {
        this.productInfoExpanded = value;
    }

    setProductInfoBig(value: boolean) {
        this.productInfoBig = value;
    }

    setShutterExpanded(value: boolean) {
        this.shutterExpanded = value;
    }

    public selectedBrickItem(): {
        position: number,
        mainNavigationKeyPath: string,
        isFreeInSet: boolean,
        gratisMlt: string
    } {
        const selectedBi = this.mainStore.dataStore.sortedBrickItems.filter(
            (it) => it.brickNo === this.openedArticleSetItem?.brickNo);

        if (selectedBi.length > 0) {
            const bi = selectedBi[0];
            return {
                position: this.mainStore.dataStore.sortedBrickItems.indexOf(bi),
                mainNavigationKeyPath: bi.mainNavigationKeyPath,
                isFreeInSet: bi.isFreeInSet,
                gratisMlt: this.mainStore.localization.generalL10n.gratis
            };
        }

        // just in case backup plan:
        return {
            position: 0,
            mainNavigationKeyPath: '',
            isFreeInSet: false,
            gratisMlt: ''
        };
    }

    // for piwik
    public getOMBrickPosition(): number {
        return this.mainStore.dataStore.orderModule.sortedBrickSelections.findIndex(
            (it) => it.brickNo === this.openedArticleSetItem?.brickNo);
    }

    public getVariantLabel(articleSetItem: IArticleSetItem | null): string {
        if (articleSetItem) {
            const colorText = articleSetItem.colorText?.trim();
            const sizeText = articleSetItem.sizeText?.trim();
            const modelText = articleSetItem.modelText?.trim();

            const returnValue: Array<string> = [];
            if (colorText && colorText.length > 0) {
                const colorLabel = this.mainStore.localization.generalL10n.textColor + ': ' + colorText;
                returnValue.push(colorLabel);
            }
            if (sizeText && sizeText.length > 0) {
                const sizeLabel = this.mainStore.localization.generalL10n.textSize + ': ' + sizeText;
                returnValue.push(sizeLabel);
            }
            if (modelText && modelText.length > 0) {
                const modelLabel = this.mainStore.localization.generalL10n.textModel + ': ' + modelText;
                returnValue.push(modelLabel);
            }
            if (returnValue.length > 0) {
                return returnValue.join(', ');
            } else {
                return '';
            }
        } else {
            return '';
        }
    }

    public handleDetailsButtonClick(value, newArticleSetItem?: IArticleSetItem) {
        if (value) {
            if (newArticleSetItem) {
                const savKeyVariants = newArticleSetItem.salesArticleVariantKey.split('-');
                const masterArticleNo = newArticleSetItem.masterArticleNo;
                this.mainStore.fetch.fetch(savKeyVariants[0], savKeyVariants[1], masterArticleNo, savKeyVariants[2])
                    .then(result => {
                        if (result) {
                            this.mainStore.scrollLock.lock()
                            this.setOpenedArticleSetItem(newArticleSetItem);
                            this.setArticleSetItemDetail(result);
                            this.setDetailsModalOpen(value);
                            this.mainStore.hideEsAppButton();
                        } else {
                            this.setArticleSetItemDetail(null);
                            this.setOpenedArticleSetItem(null);
                        }
                    });
            }
        } else {
            this.mainStore.variantStore.setDetailsModalOpen(false);
            this.mainStore.scrollLock.unlock();
            this.setDetailsModalOpen(value);
            if (!this.mainStore.variantStore.isVariantPanelOpen) {
                this.mainStore.showEsAppButton();
            }
        }
    };
}